import styled from "@emotion/styled";
import Menu from "@mui/material/Menu";

const SearchMenuBox = styled(Menu)`
  .MuiPaper-root {
    border-radius: 15px;
    padding: 8px;
    overflow: visible;
    max-width: 480px;
    max-height: 920px;
    box-shadow: unset;
    filter: drop-shadow(0px 2px 5px rgba(0, 0, 0, 0.32));
    background-color: ${({ theme }) => theme.palette.grey.g6};
    background-image: none;
  }
`;
export default SearchMenuBox;
